// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__kKTPg","bigColWidth":"Table_bigColWidth__3vS1g","biggerColWidth":"Table_biggerColWidth__1k-4Q","row":"Table_row__tLEe-","col":"Table_col__anSbZ"};